package nl.volleyplanner.web.base.component

import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import nl.volleyplanner.web.CoroutineManager
import nl.volleyplanner.web.Logger


//typealias Filter<T> = (T) -> Boolean

interface Filter<T> {
    fun showRecord(record: T) : Boolean
}

enum class CompositeFilterType {
    And,
    Or
}

interface FilterCollection<T> {
    fun hasFilter(filter: Filter<T>) : Boolean
    fun setFilters(newFilters: List<Filter<T>>)
    fun addFilter(filter: Filter<T>)
    fun removeFilter(filter: Filter<T>)
}

class CompositeFilter<T>(
    private val filterManager: FilterManager<T>,
    private val compositeFilterType: CompositeFilterType = CompositeFilterType.Or
) : Filter<T>, FilterCollection<T> {
    private val filters = mutableSetOf<Filter<T>>()

    override fun hasFilter(filter: Filter<T>): Boolean {
        return filters.contains(filter)
    }

    override fun setFilters(newFilters: List<Filter<T>>) {
        filters.clear()
        filters.addAll(newFilters)
        filterManager.runFilters()
    }

    override fun addFilter(filter: Filter<T>) {
        filters.add(filter)
        filterManager.runFilters()
    }

    override fun removeFilter(filter: Filter<T>) {
        filters.remove(filter)
        filterManager.runFilters()
    }

    override fun showRecord(record: T): Boolean {
        return if(compositeFilterType == CompositeFilterType.And) {
            filters.all { it.showRecord(record) }
        } else {
            filters.any { it.showRecord(record) }
        }
    }
}

class FilterManager<T>(private val recordsFlow: StateFlow<List<T>?>) : FilterCollection<T> {
    private val logger = Logger.getLogger("nl.volleyplanner.component.FilterManager")
    private var collectionJob: Job? = null

    private val filters = mutableSetOf<Filter<T>>()
    private val _visibleRecordsState: MutableStateFlow<List<T>> = MutableStateFlow(recordsFlow.value ?: emptyList())
    val visibleRecordsState: StateFlow<List<T>> = _visibleRecordsState.asStateFlow()

    override fun hasFilter(filter: Filter<T>) = filters.contains(filter)

    override fun setFilters(newFilters: List<Filter<T>>) {
        filters.clear()
        filters.addAll(newFilters)
        runFilters()
    }

    override fun addFilter(filter: Filter<T>) {
        if (filters.add(filter)) runFilters()
    }

    override fun removeFilter(filter: Filter<T>) {
        if(filters.remove(filter)) runFilters()
    }

    fun runFilters() {
        if (recordsFlow.value == null) {
            _visibleRecordsState.value = emptyList()
        } else {
            _visibleRecordsState.value = recordsFlow.value!!.filter { record -> filters.all { filter -> filter.showRecord(record) } }
        }
        logger.debug("Ran filters on ${recordsFlow.value?.size} records: ${_visibleRecordsState.value.size} are visible")
    }

    fun dispose() {
        collectionJob?.cancel()
    }

    fun launchManager() : Job {
        collectionJob?.cancel()
        collectionJob = CoroutineManager.RENDER_SCOPE.launch {
            recordsFlow.collect({ update ->
                logger.debug("Updated recordsFlow: ${update?.size} records retrieved")
                runFilters()
            })
        }
        return collectionJob!!
    }
}


//class FilterGroup(val groupLabel: String, val groupId: String, val filterItems: List<FilterItem>) : HTMLComponent() {
//    private val logger = Logger.getLogger("nl.volleyplanner.page.TaskAssignmentStatisticsController.FilterGroup")
//
//    val filterGroupId = groupLabel.replace(" ", "-")
//
//    init {
//        filterState.value = filterState.value.plus(filterItems.filter { it.defaultState })
//    }
//
//    fun setFilterState(filterItem: FilterItem, active: Boolean) {
//        val btnElement = document.querySelector("#${filterItem.itemId}") as HTMLButtonElement
//        if (!active) btnElement.addClass("active") else btnElement.removeClass("active")
//
//        filterState.value = if (active) filterState.value.plus(filterItem) else filterState.value.minus(filterItem)
//    }
//
//    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
//        return consumer.div (classes = "btn-group me-2") {
//            role = "group"
//            attributes["aria-label"] = "$groupLabel filter"
//
//            button(classes = "btn btn-primary") {
//                if (!filterState.value.containsAll(filterItems)) classes += "active"
//
//                type = ButtonType.button
//                +groupLabel
//
//                onClickFunction = { event ->
//                    event.preventDefault()
//                    val buttonElement = event.target as HTMLButtonElement
//                    if (filterState.value.any { filterItems.contains(it) }) {
//                        buttonElement.addClass("active")
//                        filterItems.forEach { item -> setFilterState(item, false) }
//                    } else {
//                        buttonElement.removeClass("active")
//                        filterItems.forEach { item -> setFilterState(item, true) }
//                    }
//                }
//            }
//
//            filterItems.forEachIndexed { index, item ->
//                button(classes = "btn btn-primary") {
//                    if (!item.defaultState) classes += "active"
//
//                    attributes["data-vp-filtergroup"] = filterGroupId
//                    type = ButtonType.button
//                    id = item.itemId
//
//                    onClickFunction = { event ->
//                        event.preventDefault()
//                        setFilterState(item, !filterState.value.contains(item))
//                    }
//
//                    +item.label
//                }
//            }
//        }
//    }
//
//    override suspend fun getState() = null
//}